/* eslint-disable import/no-unresolved */
/* eslint-disable no-return-assign */
/* eslint-disable security/detect-object-injection */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
import { memo } from "react";

interface Props {
  heading: string;
  options: string[];
  name: string;
  formik: any;
  className?: string;
}
function Status({ heading, options, name, className, formik: { value, setFieldValue } }: Props) {
  const handleMultiSelect = (index: number) => {
    const newValue = [...value];
    newValue[index] = !value[index];
    setFieldValue(name, newValue);
  };
  return (
    <div className={`space-y-3 ${className}`}>
      <div className="font-semibold text-sm">{heading}</div>
      <div>
        <ul className="space-y-2">
          {options?.map((ele, index) => (
            <li
              onClick={() => handleMultiSelect(index)}
              className={`text-xs px-2 py-1 rounded-md cursor-pointer ${
                value[index] ? "bg-lightQuilt border border-durotarFire" : "bg-doctor"
              }`}
              key={index}
            >
              {ele}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

Status.defaultProps = {
  className: ""
};

export default memo(Status);
